export enum DialogMode {
  ViewOnly = "viewOnly",
  Add = "add",
  Edit = "edit",
  Delete = "delete",
}
